const mediaItems = [
  {
    title: '暑期档动作巨制合集',
    desc: '高燃打斗场面，肾上腺素飙升的视觉盛宴',
    tag: '动作',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20style%20with%20dramatic%20explosion%20and%20silhouette%20of%20hero%20in%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20dark%20moody%20background%20with%20fire%20and%20smoke%2C%20epic%20blockbuster%20vibe%2C%20rich%20contrast&width=600&height=800&seq=media-action-movie&orientation=portrait',
  },
  {
    title: '年度高分悬疑剧推荐',
    desc: '反转不断，烧脑剧情让你欲罢不能',
    tag: '悬疑',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20poster%20with%20detective%20silhouette%20under%20streetlamp%20in%20foggy%20night%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20rain%20soaked%20streets%2C%20cinematic%20lighting%2C%20atmospheric%20tension&width=600&height=800&seq=media-thriller&orientation=portrait',
  },
  {
    title: '热门国剧追更日历',
    desc: '每日更新追剧不迷路，最新剧集一网打尽',
    tag: '国剧',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20costume%20drama%20poster%20with%20traditional%20hanfu%20silhouette%20against%20warm%20sunset%20sky%2C%20flowing%20silk%20fabrics%2C%20ancient%20palace%20architecture%20in%20background%2C%20soft%20golden%20light%2C%20poetic%20atmosphere&width=600&height=800&seq=media-chinese-drama&orientation=portrait',
  },
  {
    title: '经典港片回顾特辑',
    desc: '那些年我们追过的港片，情怀拉满',
    tag: '港片',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cinema%20nostalgic%20poster%20with%20neon%20signs%20and%20wet%20city%20streets%20at%20night%2C%20retro%201990s%20aesthetic%2C%20warm%20red%20and%20gold%20tones%2C%20cinematic%20noir%20style%2C%20urban%20nightscape%20with%20reflections&width=600&height=800&seq=media-hk-movie&orientation=portrait',
  },
  {
    title: '治愈系日漫精选',
    desc: '温暖人心的动画佳作，治愈你的每一天',
    tag: '日漫',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20cherry%20blossoms%20and%20warm%20sunset%20sky%2C%20soft%20dreamy%20atmosphere%2C%20Japanese%20animation%20aesthetic%2C%20gentle%20pastel%20color%20palette%20with%20warm%20golden%20accents%2C%20serene%20and%20emotional%20mood&width=600&height=800&seq=media-anime&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          精彩视频
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">热门影视精选推荐</p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden aspect-[3/4] bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium text-background-50 bg-primary-500/90 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center mx-auto mb-2 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </div>
                </div>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}